module.exports = __webpack_public_path__ + "img/btn_order_all_close02.9ad366a0.svg";